import React, {useState} from 'react';
import {Button, Descriptions, Modal} from 'antd';
import {getAgainHandler, getAgainHandlerWarningCount} from "../../store/TableRedux/TableRedux";
import {useDispatch} from "react-redux";
import Batch from "../../http_request/Model/batch/Batch";

const ConfirmModal = ({data}) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const showModal = () => {
        setOpen(true);
    };
    const handleOk = () => {

        Batch.request({
            beforeSend: () => {
                setLoading(true)
            }, success: (result) => {
                handleCancel()
                dispatch(getAgainHandler());
                dispatch(getAgainHandlerWarningCount());


            }, final: () => {
                setLoading(false)
            }


        }).Warning(data.id)


    };
    const handleCancel = () => {
        setOpen(false);
    };

    const items = [
        {
            key: '1',
            label: 'درجه اهمیت',
            children: <p>{data?.level}</p>,
        },
        {
            key: '1',
            label: 'نوع',
            children: <p>{data?.name}</p>,
        },
        {
            key: '2',
            label: 'شماره پالت',
            children: <p>{data?.palletId}</p>,
        },
        {
            key: '3',
            label: 'توسط',
            children: <p>{data?.by}</p>,
        },
        {
            key: '4',
            label: 'موقعیت',
            children: <p>{data?.location}</p>,
        },
        {
            key: '5',
            label: 'زمان',
            children: <p>{data?.time}</p>,
        },
    ];
    return (
        <>


            <Button onClick={showModal} className='defBtn blueBtn'>
                مشاهده شد</Button>


            <Modal
                open={open}
                title="مشاهده شد"
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button className='defBtn redBtn' key='back' onClick={handleCancel}>
                        انصراف
                    </Button>,
                    <Button className='defBtn blueBtn' key='submit' type='primary' loading={loading} onClick={handleOk}>
                        مشاهده
                    </Button>,

                ]}
            >


                <Descriptions items={items}/>
            </Modal>
        </>
    );
};
export default ConfirmModal;